import easIcon from "/assets/icons/eas-icon.png";

/**
 * PageLoader — full-screen branded loading screen. Theme-aware.
 *
 * Usage:
 *   if (loading) return <PageLoader />;
 *
 * Optional props:
 *   <PageLoader message="Fetching your data…" />
 *   <PageLoader size="sm" />   // sm | md (default) | lg
 */
export default function PageLoader({ message = "Please wait…", size = "md" }) {
  const iconSize = size === "sm" ? "w-12 h-12" : size === "lg" ? "w-20 h-20" : "w-16 h-16";

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-bg">
      {/* Logo with pulse ring */}
      <div className="relative flex items-center justify-center mb-6">
        <span
          className="absolute inline-flex h-full w-full rounded-full opacity-20 animate-ping"
          style={{ background: "var(--color-brand)" }}
        />
        <span
          className="absolute inline-flex rounded-full"
          style={{ width: "calc(100% + 16px)", height: "calc(100% + 16px)", background: "var(--color-brand-light)" }}
        />
        <div className={`relative ${iconSize} rounded-2xl overflow-hidden shadow-lg`}
          style={{ boxShadow: "0 10px 24px var(--color-brand-light)" }}>
          <img src={easIcon} alt="Loading" className="w-full h-full object-cover" />
        </div>
      </div>

      {/* Animated dots bar */}
      <div className="flex items-center gap-1.5 mb-4">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full"
            style={{
              background:     "var(--color-brand)",
              animation:      "loader-bounce 1.2s ease-in-out infinite",
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>

      <p className="text-muted text-xs font-medium tracking-wide">{message}</p>

      <style>{`
        @keyframes loader-bounce {
          0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
          40%            { transform: scale(1);   opacity: 1;   }
        }
      `}</style>
    </div>
  );
}
